import moment from 'moment';

/**
 * 依日曆單位算報表的本期範圍。銷售方案統計與通路統計共用。
 *
 * 兩個查詢維度的收斂規則刻意不同：
 *  - book (依進單日)：當期收斂到今天 —— 訂房日不可能落在未來，給整期只會拉出一段空白。
 *  - stay (依入住日)：一律取完整期間 —— 這是 on-the-books (在帳) 的成份視角，
 *    未來的入住日本來就該算進來。
 *
 * 副作用：stay 模式的「較上期」變成完整月 vs 完整月 (期間對齊反而更正確)，
 * 但本期未來的部分還在持續進單，絕對量會偏低 —— 頁面 Popover 需標註。
 * 上期一律由後端以「前一段等長區間」推算，前端不傳。
 *
 * @param {'month'|'quarter'|'year'} unit 日曆單位
 * @param {moment} anchor 落在目標期間內的任一天
 * @param {'stay'|'book'} basis 查詢維度
 * @param {moment} [now] 注入「今天」以利測試
 * @returns {{from: moment, to: moment}}
 */
export function periodRange(unit, anchor, basis, now = moment()) {
  const from = anchor.clone().startOf(unit);
  const isCurrent = anchor.isSame(now, unit);
  const to = isCurrent && basis === 'book' ? now.clone() : anchor.clone().endOf(unit);
  return { from, to };
}
